import { FC, useMemo } from 'react';
import { hasSuperScripts } from 'modules/benefitsWellness/util';
import { IN_NETWORK, OUT_OF_NETWORK } from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';
import { useAppSelector } from 'hooks/redux';
import { useMultiTableHeightSync } from 'modules/benefitsWellness/components/TableContext/TableContextProvider';

import styles from './planCardBody.module.less';

const PlanCardBody: FC<any> = (props: any) => {
  const { mappings, plan } = props;
  const language = useAppSelector((state) => state.benguide.data?.language);

  // Collect all field names for height synchronization
  const fieldNames = useMemo(() => {
    const names: string[] = [];
    mappings.forEach((mapping: any, sectionIndex: any) => {
      mapping.fields.forEach((key: any, index: any) => {
        names.push(key.fieldName || `value-${sectionIndex}-${index}`);
      });
    });
    return names;
  }, [mappings]);

  // Use multi-table height sync for all field names
  const { heights, refs } = useMultiTableHeightSync(fieldNames, 0);

  const generateCardRows = () => {
    const rows = [] as any[];
    mappings.forEach((mapping: any, sectionIndex: any) => {
      const sectionNameDiv = (
        <div
          key={'pr-details-section-' + sectionIndex}
          className={
            mapping.sectionName
              ? styles.cardBodyTitleSection
              : styles.cardBodyNoTitleSection
          }
        ></div>
      );
      rows.push(sectionNameDiv);
      mapping.fields.forEach((key: any, index: any) => {
        const fieldName = key.fieldName || `value-${sectionIndex}-${index}`;
        const valueHeight = heights[fieldName];
        const valueRef = refs[fieldName];

        if (index % 2) {
          const row = (
            <div
              key={'pr-details-row-' + sectionIndex + index}
              className={styles.cardBodyRowCaontainer}
              ref={valueRef}
              style={{ height: valueHeight }}
            >
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyLight
                }`}
                style={{ height: valueHeight }}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.inNetworkTitle}
                >
                  {key.inNetworkValue}
                </div>
              </div>
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyLight
                }`}
                style={{ height: valueHeight }}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.outOfNetworkTitle}
                >
                  {key.outOfNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        } else {
          const row = (
            <div
              key={'pr-details-row-' + sectionIndex + index}
              className={`${styles.cardBodyRowCaontainer} ${
                index === 0 &&
                mapping.sectionName &&
                styles.cardBodyRowBorderContainer
              }`}
              ref={valueRef}
              style={{ height: valueHeight }}
            >
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyDark
                }`}
                style={{ height: valueHeight }}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.inNetworkTitle}
                >
                  {key.inNetworkValue}
                </div>
              </div>
              <div
                className={`${styles.cardBodyRow} ${
                  mapping.sectionName && styles.cardBodyDark
                }`}
                style={{ height: valueHeight }}
              >
                <div
                  className={styles.cardBodyValue}
                  title={key.outOfNetworkTitle}
                >
                  {key.outOfNetworkValue}
                </div>
              </div>
            </div>
          );
          rows.push(row);
        }
      });
      const seperator = (
        <div
          key={'pr-details-separator-' + sectionIndex}
          className={styles.cardBodyRowSeperator}
        ></div>
      );
      rows.push(seperator);
    });
    return rows;
  };

  const cardRows = generateCardRows();
  const availableSuperScripts = hasSuperScripts([plan], 'InNetwork');
  hasSuperScripts([plan], 'OutOfNetwork').forEach((a) => {
    availableSuperScripts.add(a);
  });

  return (
    <div>
      <div className={styles.planDetailCardTitles}>
        <div className={styles.planCardInTitle}>
          {getText(IN_NETWORK, language)}
        </div>
        <div className={styles.planCardOutTitle}>
          {getText(OUT_OF_NETWORK, language)}
        </div>
      </div>
      <div className={styles.planDetailCardBody}>{cardRows}</div>
    </div>
  );
};

export default PlanCardBody;
